import React from 'react'
import { Chip } from '../Chip'
import type { ChipSize } from '../Chip'

export interface ICapsuleProps {
  label: React.ReactNode
  color?: string
  size?: ChipSize
  [key: string]: any
}

export const Capsule: React.FC<ICapsuleProps> = ({ label, color = '#64748B', size = 'sm', ...rest }) => (
  <Chip label={label} color={color} variant="filled" size={size} radius="999px" {...rest} />
)
